import TeamBuilder from '../TeamBuilder/Index';

export default function TeamBuilderStep({
  competition,
  competitionDate,
  teamMembers,
  setTeamMembers,
  divisionSelection,
  setterOptions,
  closerOptions,
  rookieOptions,
  veteranOptions,
  createTeam,
  editingTeam,
  setStep,
  setTeam,
  officeOptions,
  editingTeamId,
  onSubmit
}) {
  return (
    <TeamBuilder
      competition={competition}
      competition_event={competitionDate}
      teamMembers={teamMembers}
      setTeamMembers={setTeamMembers}
      divisionSelection={divisionSelection}
      setterTeamMemberOptions={setterOptions}
      closerTeamMemberOptions={closerOptions}
      veteranTeamMemberOptions={veteranOptions}
      rookieTeamMemberOptions={rookieOptions}
      createTeam={createTeam}
      editingTeam={editingTeam}
      setStep={setStep}
      setTeam={setTeam}
      officeOptions={officeOptions}
      editingTeamId={editingTeamId}
      onSubmit={onSubmit}
    />
  );
}